import * as React from "react";
import { ReviewScreen } from "../components/ReviewScreen";
import { isLoading, loading, Loading } from "../Loading";
import { API } from "../API";
import { Intent, Spinner } from "@blueprintjs/core";

interface ReviewActivityProps {
    api: API;
    stopSectionText: string | null;
    areAllSectionsDone: boolean;
    requiredFiles: string[];
    onMobileClose: () => void;
}

interface ReviewActivityState {
    body: string | null | Loading;
}

export class ReviewActivity extends React.Component<ReviewActivityProps, ReviewActivityState> {
    constructor(props: ReviewActivityProps) {
        super(props);
        this.state = {
            body: null
        };
    }

    render() {
        if (isLoading(this.state.body)) {
            return (
              <div className={"DocumentOverlayContentComponent_loadingSpinner"}>
                <Spinner intent={Intent.PRIMARY} />
              </div>
            );
        }
        return (
            <ReviewScreen
                header={this.props.stopSectionText}
                body={this.state.body}
                caregiver={this.props.api.authInfo.caregiver}
                close={this.props.onMobileClose}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/activities/ReviewActivity.tsx